import { Controller } from "@hotwired/stimulus"

// A code snippet, a backtrace line, or a wide table can end up scrollable depending on its
// actual content and the viewport it renders in, but neither a <pre> nor a plain scrolling
// <div> (Bootstrap's .table-responsive) is in the tab order by default, so a keyboard-only user
// has no way to scroll one at all (WCAG 2.1.1, axe-core's scrollable-region-focusable check).
//
// Scoped to <main> in the layout, not one data-controller per <pre>/.table-responsive: this
// app has dozens of them (the help guide's per-language install snippets alone), and every page
// gets covered automatically this way, present and future, with no per-view markup to remember.
//
// tabindex is only added where content actually overflows right now, not unconditionally: a
// snippet or table that fits shouldn't pick up a pointless extra stop in keyboard navigation.
export default class extends Controller {
  connect() {
    this.markOverflowing(this.element)

    // A collapsed <details> (the issue-show Backtrace/Context blocks, e.g.) has no layout at all
    // while closed, so scrollWidth/clientWidth both read 0 and nothing inside it looks like it
    // overflows yet; re-check just that <details>'s own contents once it actually opens, native
    // "toggle" doesn't bubble so this has to be bound per-element rather than once on `this.element`.
    this.detailsElements = [ ...this.element.querySelectorAll("details") ]
    this.onToggle = (event) => this.markOverflowing(event.target)
    this.detailsElements.forEach((el) => el.addEventListener("toggle", this.onToggle))
  }

  disconnect() {
    this.detailsElements?.forEach((el) => el.removeEventListener("toggle", this.onToggle))
  }

  markOverflowing(root) {
    root.querySelectorAll("pre, .table-responsive").forEach((el) => {
      const overflows = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
      if (overflows) el.setAttribute("tabindex", "0")
    })
  }
}
